
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.528 7.2h-3.9L2.884 9H.892L4.636.6h1.92L10.312 9h-2.04l-.744-1.8zm-.612-1.476L5.584 2.508 4.252 5.724h2.664zm6.744-3.276c1 0 1.768.238 2.304.714.536.476.804 1.194.804 2.154V9h-1.752v-.804c-.352.6-1.008.9-1.968.9-.496 0-.926-.084-1.29-.252a1.924 1.924 0 01-.834-.696 1.811 1.811 0 01-.288-1.008c0-.6.226-1.072.678-1.416.452-.344 1.15-.516 2.094-.516h1.488c0-.408-.124-.722-.372-.942-.248-.22-.62-.33-1.116-.33-.344 0-.682.054-1.014.162a2.683 2.683 0 00-.846.438l-.672-1.308c.352-.248.774-.44 1.266-.576a5.671 5.671 0 011.518-.204zm-.144 5.388c.32 0 .604-.074.852-.222.248-.148.424-.366.528-.654V6.3h-1.284c-.768 0-1.152.252-1.152.756 0 .24.094.43.282.57.188.14.446.21.774.21z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    